export default "__VITE_ASSET__u0jVqp5P__"